import moment from 'moment';

/** Legacy operational dates are in Bishkek; ISO dates carry their own offset. */
export const parseDateToMoment = (value) => {
  if (!value) return null;
  if (moment.isMoment(value)) return value.isValid() ? value.clone() : null;
  const legacy = typeof value === 'string' && value.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/);
  const date = legacy ? moment.parseZone(`${legacy[3]}-${legacy[2]}-${legacy[1]}T${legacy[4]}:${legacy[5]}:${legacy[6] || '00'}+06:00`, moment.ISO_8601, true)
    : value instanceof Date ? moment(value) : moment.parseZone(value, moment.ISO_8601, true);
  return date.isValid() ? date : null;
};

export const parseAndFormatDate = (value, outputFormat = 'DD.MM.YYYY HH:mm') => {
  if (!value) return '—';
  const date = parseDateToMoment(value);
  return date ? date.utcOffset(6).format(outputFormat) : value;
};
